<template>
  <div class="outer-container">
    <img
      :style="{ 'border-radius': rounded ? '15px' : '0' }"
      :src="imgSrc"
      :alt="imgAlt"
    >

    <div class="text-box">
      <div class="text">
        {{ title }}
      </div>

      <div class="btn-container">
        <base-button :text="btnText" :class="cssClass" @click="onClick()" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GiftButtonCard",
  props: {
    title: {
      type: String,
      required: true
    },
    btnText: {
      type: String,
      required: true
    },
    rounded: {
      type: Boolean,
      default: false
    },
    imgSrc: {
      type: String,
      required: true
    },
    imgAlt: {
      type: String,
      required: true
    },
    cssClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    onClick () {
      this.$emit("btnClick")
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./scss/variables";

.outer-container {
  width: 100%;
  max-width: 380px;
  margin-bottom: 50px;
}

.text-box {
  border: 1px solid $light-grey;
  border-top: 0px;
  height: 120px;
  text-align: center;
  padding-top: 24px;
  box-sizing: border-box;
  position: relative;

  .text {
    font-size: 19px;
    font-weight: 600;
  }

  .btn-container {
    position: absolute;
    bottom: 0;
    transform: translateY(50%) translateX(50%);
    right: 50%;
  }
}

img {
  width: 100%;
  height: 250px;
}
</style>
